const COLORS = [
  "var(--spark-gold)",
  "var(--secondary)",
  "var(--tertiary)",
  "var(--primary)",
  "#A8D5E0",
];

/** A single burst. Keyed by `at` so a new value restarts it. */
export function Confetti({ at }: { at: number }) {
  return (
    <div
      aria-hidden="true"
      style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}
    >
      {Array.from({ length: 42 }, (_, i) => (
        <span
          key={`${at}-${i}`}
          style={{
            position: "absolute",
            top: 0,
            left: `${(2 + i * 2.3) % 96}%`,
            width: 8,
            height: 13,
            borderRadius: 2,
            background: COLORS[i % COLORS.length],
            animation: `confFall ${1.4 + (i % 5) * 0.25}s ease-in forwards`,
            animationDelay: `${(i % 7) * 0.09}s`,
          }}
        />
      ))}
    </div>
  );
}
